export default __webpack_public_path__ + "static/media/login.0507f54a.jpg";